import { atom } from "recoil";
import theme from "../theme";

export const filters = atom({
  key: "filters",
  default: {
    host_level: null,
    host_id: null,
    period: "monthly",
    //dates: [new Date(2020, 0, 1), new Date(2020, 0, 31)],
    dates: [],
    position: []
  }
});

export const layout = atom({
  key: "layout",
  default: "full"
});

export const token = atom({
  key: "token",
  default: null
});

export const reportID = atom({
  key: "reportID",
  default: null
});

export const appTheme = atom({
  key: "mode",
  default: {
    mode: "light",
    theme
  }
});

export const url = atom({
  key: "url",
  default: null
});

export const dates = atom({
  key: "dates",
  default: [new Date(2020, 2, 1), new Date(2020, 2, 31)]
});

export const data = atom({
  key: "data",
  default: {}
});
